/**
 * @generated SignedSource<<c3ea9122b1eb285b4264b9443d4c162e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ViewNotFoundErrorPage$data = {
  readonly url: string | null | undefined;
  readonly " $fragmentType": "ViewNotFoundErrorPage";
};
export type ViewNotFoundErrorPage$key = {
  readonly " $data"?: ViewNotFoundErrorPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewNotFoundErrorPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ViewNotFoundErrorPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "d78a5a29cac71468d9323286e7568bfd";

export default node;
